import { IPreviewSigning } from "../../models/models";

export const PREVIEW_AND_SIGNING_FORM_INITIAL_VALUE: IPreviewSigning = {
	ra: {
		raNumber: '',
		dmsIdentificationCode: null,
		pickUpDate: null,
		renewalsAndSubstitutions: '',
		dmsOperatorInCharge: '',
		tenant: '',
		dealer: ''
	},
	vehicleState: {
		acriss: '',
		sipp: '',
		plateNumber: '',
		vehicleId: '',
		energyType: '',
		kmOnStart: '',
		fuelOnStart: '',
		batteryOnStart: '',
		rfidCard: '',
		eToll: '',
		chargingCableType2: '',
		chargingCableDomesticType: '',
		keyless: ''
	},
	signedDocument: null
}

export const DOWNLOAD_PDF_TYPE = {
	RA: "RA",
	CHECKIN: "CHECKIN",
	CHECKOUT: "CHECKOUT",
	RA_SOSTITUZIONE: "RA_SOSTITUZIONE"
}

